import React from "react";

import "../../styles/_thankyou.scss";

class ThankYou extends React.Component {
  render() {
    return (
      <div className="thank-you">
        <h1 className="thank-you-header">Thank you!</h1>
        <div className="thank-you-content">
          <div className="thank-you-info">
            <div className="info-message">
              <p>Your Bind Request has been submitted.</p>
              <p>
                We appreciate your business! Your Placement Specialist will
                review this bind request. Please allow 24 hours for confirmation
                of bind or further notification from Northeast Agencies.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ThankYou;
